import v2 from './v2';
import { blue, Direction, red } from "./util";
import { selection, squareSize } from "./game";
import { green, worldSpaceToScreenSpace } from "./util";
import { arrow, circle, rect } from "./drawing";
export var ct;
(function (ct) {
    ct[ct["wire"] = 0] = "wire";
    ct[ct["light"] = 1] = "light";
    ct[ct["power"] = 2] = "power";
    ct[ct["switch"] = 3] = "switch";
    ct[ct["not"] = 4] = "not";
    ct[ct["custom"] = 5] = "custom";
    ct[ct["delay"] = 6] = "delay";
    ct[ct["clock"] = 7] = "clock";
})(ct || (ct = {}));
export class Component {
    constructor(position, type, order, direction) {
        this.order = order;
        if (Array.isArray(position))
            this.position = v2.fromArray(position);
        else
            this.position = position;
        this.type = type;
        // not powered at start if it isn't a power block
        this.powered = this.type === ct.power;
        this.rotation = new Direction(direction);
    }
    static createFromJSON(json) {
        return new componentTypeToClass[json.type](json);
    }
}
export class Wire extends Component {
    constructor({ to = v2.zero, position = v2.zero, }) {
        super(position, ct.wire, 0, 0);
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type,
                to: this.to.array
            };
        };
        this.tick = (at) => {
            if (this.powered) {
                let newPower = false;
                for (let comp of at(this.to)) {
                    if (!comp.powered) {
                        comp.powered = true;
                        newPower = true;
                    }
                }
                return newPower;
            }
            else
                return false;
        };
        this.onclick = () => void 0;
        this.draw = (at, props) => {
            let endPos = this.to.clone.mul(squareSize).add(squareSize / 2);
            const endRenderPos = worldSpaceToScreenSpace(endPos, props.camPos, props.width, props.height, props.zoom);
            arrow(props.context, at.clone.add(squareSize * props.zoom / 2), endRenderPos, props.zoom * 10, this.powered ? 'rgb(255,0,0)' : 'rgb(127,53,53)', 0.5);
        };
        this.beforeTick = () => void 0;
        this.afterTick = () => void 0;
        this.to = v2.fromArray(to);
    }
}
export class Light extends Component {
    constructor({ position = v2.zero, colour = red }) {
        super(position, ct.light, 1, 0);
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type,
                colour: this.colour
            };
        };
        this.tick = () => false;
        this.onclick = () => {
            if (this.colour === red)
                this.colour = green;
            else if (this.colour === green)
                this.colour = blue;
            else
                this.colour = red;
            selection.set([]);
        };
        this.draw = (at, props) => {
            if (this.powered) {
                rect(props.context, at, squareSize * props.zoom, squareSize * props.zoom, this.colour);
                return;
            }
            circle(props.context, at.clone.add(squareSize * props.zoom / 2), squareSize * props.zoom / 4, 'rgb(186,186,186)');
        };
        this.beforeTick = () => void 0;
        this.afterTick = () => void 0;
        this.colour = colour;
    }
}
export class Power extends Component {
    constructor({ position = v2.zero }) {
        super(position, ct.power, 2, 0);
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type
            };
        };
        this.tick = (at) => {
            this.powered = true;
            let newPower = false;
            for (let comp of at(this.position)) {
                if (!comp.powered) {
                    comp.powered = true;
                    newPower = true;
                }
            }
            return newPower;
        };
        this.onclick = () => void 0;
        this.draw = (at, props) => {
            rect(props.context, at, squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(153,153,153)' : 'rgb(0,0,0)');
        };
        this.beforeTick = () => void 0;
        this.afterTick = () => void 0;
    }
}
export class Switch extends Component {
    constructor({ position = v2.zero, rotation = 0 }) {
        super(position, ct.switch, 2, rotation);
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type,
                state: this.state,
                rotation: this.rotation.d
            };
        };
        this.tick = (at) => {
            if (this.powered && this.state) {
                let newPower = false;
                for (let comp of at(this.position.clone.add(this.rotation.forwards))) {
                    if (!comp.powered) {
                        comp.powered = true;
                        newPower = true;
                    }
                }
                return newPower;
            }
            else
                return false;
        };
        this.onclick = () => {
            this.state = !this.state;
        };
        this.draw = (at, props) => {
            rect(props.context, at, squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(250,123,123)' : 'rgb(210,210,210)');
            rect(props.context, at.clone.add(this.rotation.forwards.mul(squareSize * props.zoom)), squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(250,123,123)' : 'rgb(210,210,210)');
            circle(props.context, at.clone.add(squareSize * props.zoom / 2), squareSize * props.zoom / 4, this.state ? 'rgb(0,255,0)' : 'rgb(255,0,0)');
        };
        this.beforeTick = () => void 0;
        this.afterTick = () => void 0;
        this.state = false;
    }
}
export class Not extends Component {
    constructor({ position = v2.zero, rotation = 0 }) {
        super(position, ct.not, 2, rotation);
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type,
                rotation: this.rotation.d
            };
        };
        this.tick = () => false;
        this.onclick = () => void 0;
        this.draw = (at, props) => {
            rect(props.context, at, squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(250,123,123)' : 'rgb(210,210,210)');
            rect(props.context, at.clone.add(this.rotation.forwards.mul(squareSize * props.zoom)), squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(250,123,123)' : 'rgb(210,210,210)');
            circle(props.context, at.clone.add(squareSize * props.zoom / 2), squareSize * props.zoom / 4, 'rgb(66,117,226)');
        };
        this.beforeTick = () => void 0;
        this.afterTick = (at) => {
            if (!this.powered) {
                let newPower = false;
                for (let comp of at(this.position.clone.add(this.rotation.forwards))) {
                    if (!comp.powered) {
                        comp.powered = true;
                        newPower = true;
                    }
                }
                return newPower;
            }
            else
                return false;
        };
    }
}
export class Delay extends Component {
    constructor({ position = v2.zero, rotation = 0 }) {
        super(position, ct.delay, 2, rotation);
        this.state = false;
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type,
                rotation: this.rotation.d
            };
        };
        this.tick = (at) => {
            if (!this.powered)
                return false;
            if (this.state) {
                let newPower = false;
                for (let comp of at(this.position.clone.add(this.rotation.forwards))) {
                    if (!comp.powered) {
                        comp.powered = true;
                        newPower = true;
                    }
                }
                return newPower;
            }
            setTimeout(() => {
                this.state = true;
            }, 100);
            return false;
        };
        this.onclick = () => void 0;
        this.draw = (at, props) => {
            rect(props.context, at, squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(248,179,179)' : 'rgb(210,210,210)');
            rect(props.context, at.clone.add(this.rotation.forwards.mul(squareSize * props.zoom)), squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(248,179,179)' : 'rgb(210,210,210)');
            circle(props.context, at.clone.add(squareSize * props.zoom / 2), squareSize * props.zoom / 4, 'rgba(217,104,25,0.86)');
        };
        this.beforeTick = () => void 0;
        this.afterTick = () => {
            if (!this.powered)
                this.state = false;
            return false;
        };
    }
}
export class Clock extends Component {
    constructor({ position = v2.zero, interval = 100 }) {
        super(position, ct.clock, 2, 0);
        this.lastPulse = performance.now();
        this.jsonify = () => {
            return {
                position: this.position.array,
                type: this.type,
                interval: this.interval
            };
        };
        this.tick = (at) => {
            if (performance.now() - this.lastPulse < this.interval)
                return false;
            this.powered = true;
            let newPower = false;
            for (let comp of at(this.position)) {
                if (!comp.powered) {
                    comp.powered = true;
                    newPower = true;
                }
            }
            if (performance.now() - this.lastPulse > this.interval * 2) {
                this.lastPulse = performance.now();
            }
            return newPower;
        };
        this.onclick = () => {
            this.interval *= 2;
        };
        this.draw = (at, props) => {
            rect(props.context, at, squareSize * props.zoom, squareSize * props.zoom, this.powered ? 'rgb(153,153,153)' : 'rgb(0,0,0)');
        };
        this.beforeTick = () => void 0;
        this.afterTick = () => void 0;
        this.interval = interval;
    }
}
export const componentTypeToClass = {
    [ct.wire]: Wire,
    [ct.power]: Power,
    [ct.light]: Light,
    [ct.switch]: Switch,
    [ct.not]: Not,
    [ct.delay]: Delay,
    [ct.clock]: Clock
};
